import { useNavigate } from 'react-router-dom';
import { Layout, Row, Col, Button } from 'antd';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '@common/LanguageSwitcher';

const { Content } = Layout;
const { Title } = Typography;

function AuthLayout({ children }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <Layout
      className="layout-auth-hero"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Content className="d-flex flex-column px-5 py-4">
        {/* style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '32px 16px' }} */}
        <div className="text-end">
          <LanguageSwitcher />
        </div>
        <Row
          className="my-auto"
          justify="center"
          align="middle"
          style={{ width: '100%' }}
          gutter={[32, 32]}
        >
          <Col xs={24} md={12} xxl={10}>
            <Title
              level={1}
              className="fw-bold text-white"
              style={{
                fontSize: '3.5rem',
                // wordBreak: i18n.language === 'zh' ? 'break-all' : 'keep-all',
              }}
            >
              {t('글로벌 협력사 온실가스 배출량 정보 등록1')}
            </Title>
            <div style={{ textAlign: 'left' }}>
              <Button
                className="text-center h-auto rounded-pill border border-dark bg-dark text-white shadow-sm mb-3 py-2 px-5"
                onClick={() => navigate('/register')}
                style={{ fontSize: '17px' }}
              >
                {t('가입 및 신청하기')}
              </Button>
            </div>
          </Col>

          <Col xs={24} md={{ span: 8, offset: 1 }}>
            {children}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
}

export default AuthLayout;
